export default "__VITE_ASSET__fe7beoCw__"